interface PeopleConnectedByGearSVGProps {
  color: string;
  style: React.CSSProperties;
}

const PeopleConnectedByGearSVG = ({
  color,
  style,
}: PeopleConnectedByGearSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="54"
    height="47"
    viewBox="0 0 54 47"
    fill="none"
  >
    <path
      d="M37.6277 12.2213H44.8602C45.3782 12.2213 45.7955 12.6386 45.7955 13.1538V26.9107"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.92096 26.9135V13.1566C7.92096 12.6386 8.34115 12.2241 8.85631 12.2241H15.9017"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.7114 26.9135V23.0397"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.7633 23.0426C32.762 23.0426 37.6249 18.199 37.6249 12.2242C37.6249 6.24934 32.762 1.40576 26.7633 1.40576C20.7646 1.40576 15.9017 6.24934 15.9017 12.2242C15.9017 18.199 20.7646 23.0426 26.7633 23.0426Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.4272 12.2241C32.4272 11.8673 32.3898 11.5162 32.3264 11.1765L33.7683 10.0138C33.61 9.51018 33.3971 9.01516 33.1208 8.54029C32.8445 8.06542 32.5193 7.63372 32.1624 7.24519L30.4298 7.90713C29.9003 7.45528 29.2844 7.09841 28.6109 6.86242L28.3203 5.03488C27.8022 4.91976 27.2669 4.85645 26.7143 4.85645C26.1618 4.85645 25.6264 4.92264 25.1084 5.03488L24.8177 6.86242C24.1443 7.09841 23.5284 7.45528 22.9988 7.90713L21.2663 7.24519C20.9094 7.63372 20.5842 8.06542 20.3079 8.54029C20.0316 9.01516 19.8215 9.51018 19.6603 10.0138L21.1022 11.1765C21.0389 11.5162 21.0015 11.8644 21.0015 12.2241C21.0015 12.5839 21.0389 12.9321 21.1022 13.2717L19.6603 14.4344C19.8186 14.9381 20.0316 15.4331 20.3079 15.908C20.5842 16.3829 20.9094 16.8146 21.2663 17.2031L22.9988 16.5411C23.5284 16.993 24.1443 17.3499 24.8177 17.5859L25.1084 19.4134C25.6264 19.5285 26.1618 19.5918 26.7143 19.5918C27.2669 19.5918 27.8022 19.5256 28.3203 19.4134L28.6109 17.5859C29.2844 17.3499 29.9003 16.993 30.4298 16.5411L32.1624 17.2031C32.5193 16.8146 32.8445 16.3829 33.1208 15.908C33.3971 15.4331 33.6072 14.9381 33.7683 14.4344L32.3264 13.2717C32.3898 12.9321 32.4272 12.5839 32.4272 12.2241Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.7114 14.7281C28.1006 14.7281 29.2268 13.607 29.2268 12.2242C29.2268 10.8414 28.1006 9.72034 26.7114 9.72034C25.3222 9.72034 24.196 10.8414 24.196 12.2242C24.196 13.607 25.3222 14.7281 26.7114 14.7281Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.6942 34.5689C28.7367 34.5689 30.3924 32.8552 30.3924 30.7412C30.3924 28.6272 28.7367 26.9135 26.6942 26.9135C24.6517 26.9135 22.996 28.6272 22.996 30.7412C22.996 32.8552 24.6517 34.5689 26.6942 34.5689Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33.7798 44.2477C33.7798 44.2477 33.4345 36.8138 29.0455 36.6785C27.2496 36.6239 25.6926 36.644 24.3889 36.6699C19.8129 36.7591 19.8589 44.2938 19.8589 44.2966C19.8589 44.9701 22.9758 45.5169 26.8208 45.5169C30.6658 45.5169 33.7827 44.9701 33.7827 44.2966C33.7827 44.2822 33.7798 44.265 33.7769 44.2506H33.7827L33.7798 44.2477Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.92096 34.5689C9.96344 34.5689 11.6192 32.8552 11.6192 30.7412C11.6192 28.6272 9.96344 26.9135 7.92096 26.9135C5.87847 26.9135 4.22272 28.6272 4.22272 30.7412C4.22272 32.8552 5.87847 34.5689 7.92096 34.5689Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.0037 44.2477C15.0037 44.2477 14.6583 36.8138 10.2694 36.6785C8.4735 36.6239 6.9165 36.644 5.61276 36.6699C1.03673 36.7591 1.08278 44.2938 1.08278 44.2966C1.08278 44.9701 4.19966 45.5169 8.04468 45.5169C11.8897 45.5169 15.0066 44.9701 15.0066 44.2966C15.0066 44.2822 15.0037 44.265 15.0008 44.2506H15.0066L15.0037 44.2477Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M45.7955 34.5689C47.838 34.5689 49.4938 32.8552 49.4938 30.7412C49.4938 28.6272 47.838 26.9135 45.7955 26.9135C43.753 26.9135 42.0973 28.6272 42.0973 30.7412C42.0973 32.8552 43.753 34.5689 45.7955 34.5689Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M52.8783 44.2477C52.8783 44.2477 52.5329 36.8138 48.1439 36.6785C46.3481 36.6239 44.7911 36.644 43.4873 36.6699C38.9113 36.7591 38.9574 44.2938 38.9574 44.2966C38.9574 44.9701 42.0742 45.5169 45.9193 45.5169C49.7643 45.5169 52.8811 44.9701 52.8811 44.2966C52.8811 44.2822 52.8783 44.265 52.8754 44.2506H52.8811L52.8783 44.2477Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default PeopleConnectedByGearSVG;
